export default {
  methods: {
    getStockStatusColor(status) {
      const statusLowerCase = status ? status.toLowerCase() : '';
      switch (statusLowerCase) {
        case 'disponible':
        case 'verde':
        case 'available':
          return 'in-stock-bg';
        case 'parcial':
        case 'amarillo':
        case 'partial':
          return 'partial-stock-bg';
        default:
          return 'no-stock-bg';
      }
    },
  },
};
